import React from 'react';
import {
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

export const MeetingListEmptyState = () => (
  <VStack height={'160px'} gap={'4px'} w={'100%'}>
    <VStack
      borderColor={'cloud.200'}
      borderWidth={1}
      borderRadius={'8px'}
      flex={1}
      padding={'16px'}
      width={'100%'}
    >
      <Text>There are no bookable meetings with this host.</Text>
    </VStack>
  </VStack>
);
